import { render, staticRenderFns } from "./go-top.vue?vue&type=template&id=44bc9140&scoped=true"
import script from "./go-top.vue?vue&type=script&lang=js"
export * from "./go-top.vue?vue&type=script&lang=js"
import style0 from "./go-top.vue?vue&type=style&index=0&id=44bc9140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc9140",
  null
  
)

export default component.exports